var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3125",
    "data-name": "Group 3125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.829,
    height: 17.829,
    viewBox: "0 0 17.829 17.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M14.832,8a6.381,6.381,0,0,1-6.489,6.268A6.381,6.381,0,0,1,1.856,8,6.381,6.381,0,0,1,8.344,1.731,6.381,6.381,0,0,1,14.832,8Z",
    transform: "translate(0.935 0.953)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8471",
    "data-name": "Path 8471",
    d: "M14.71,12.884h0A1.727,1.727,0,0,1,12.6,14.669a16.491,16.491,0,0,1-6.786-4.322C2.048,6.705.079,2.7,1.421,1.406a2.269,2.269,0,0,1,2.114-.293",
    transform: "translate(1.057 1.057)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.e76302bf74863cc3164d16409d3df152.svg";
export { ForwardRef as ReactComponent };